import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { TagManagerService } from '../services/tag-manager.service';

function resolveComponentName(url: string): string {
  const normalized = url.toLowerCase();

  if (normalized.includes('api/menu')) {
    return 'Menu BFF';
  }
  if (normalized.includes('autenticacion') || normalized.includes('api/v1/autenticacion')) {
    return 'Auth';
  }
  if (normalized.includes('api/banner')) {
    return 'Banner';
  }

  return 'API';
}

function sanitizeErrorMessage(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed.length > 200) {
    return null;
  }

  if (/bearer\s+/i.test(trimmed) || /eyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+/i.test(trimmed)) {
    return null;
  }

  return trimmed;
}

function buildDlErrorMessage(req: HttpRequest<unknown>, err: HttpErrorResponse): string {
  let pathname = req.url;

  try {
    pathname = new URL(req.url, window.location.origin).pathname;
  } catch {
    // Mantiene req.url si no es parseable.
  }

  const parts = [`${req.method} ${pathname}`, `HTTP ${err.status || 0}`];

  const fromBody =
    sanitizeErrorMessage((err.error as { message?: unknown })?.message)
    ?? sanitizeErrorMessage((err.error as { error?: unknown })?.error)
    ?? sanitizeErrorMessage(err.message);

  if (fromBody) {
    parts.push(fromBody);
  } else if (err.statusText) {
    parts.push(err.statusText);
  }

  return parts.join(' - ');
}

export function GtmErrorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const tagManager = inject(TagManagerService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        tagManager.logError({
          dl_error: buildDlErrorMessage(req, err),
          component_name: resolveComponentName(req.url),
        });
      } else {
        tagManager.logError({
          dl_error: `${req.method} ${req.url} - Error de red`,
          component_name: resolveComponentName(req.url),
        });
      }

      return throwError(() => err);
    })
  );
}
